import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border border-slate-800 rounded-lg bg-[#0F172A] overflow-hidden transition-all duration-300" data-id="element-1">
      <button className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none" onClick={onClick} aria-expanded={isOpen} data-id="element-2">
        <span className="font-bold text-white text-lg pr-4" data-id="element-3">{question}</span>
        <ChevronDown className={`w-5 h-5 text-teal-400 transition-transform duration-300 flex-shrink-0 ${isOpen ? 'rotate-180' : ''}`} data-id="element-4" />
      </button>

      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-5">
        <div className="px-6 pb-5 text-[#E8E8E8] text-lg leading-relaxed" data-id="element-6">
          {answer}
        </div>
      </div>
    </div>;
}
export function FAQAccordion() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Cuánto tiempo al día necesito?',
    answer: 'Menos de 15 minutos totales divididos en pequeñas pausas de rescate a lo largo de tu día. No necesitas horas libres.'
  }, {
    question: '¿Debo comprar suplementos caros?',
    answer: 'No, usamos alimentos reales y herramientas que ya tienes en casa. El enfoque está en la regulación del sistema nervioso, no en pastillas mágicas.'
  }, {
    question: '¿Es seguro si tengo hipotiroidismo?',
    answer: 'Sí, de hecho, bajar el estrés crónico es vital para la función tiroidea óptima. Un sistema nervioso regulado apoya tu metabolismo.'
  }, {
    question: '¿Recibo acceso inmediato?',
    answer: 'Sí, descarga todo el material en PDF y video al instante tras tu pago seguro. Podrás empezar hoy mismo.'
  }];
  return <div className="space-y-4 w-full max-w-3xl mx-auto" data-id="element-7">
      {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-8" />)}
    </div>;
}